import { Box } from "@chakra-ui/react";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { preserveAdminThemeDuringClear } from "../../utils/adminThemeStorage";

const StudentWrapper = ({ children, roles }) => {
  const lang = localStorage.getItem("lang");
  const data = useSelector((state) => state.user.userData);
  const token = window.localStorage.getItem("token");

  useEffect(() => {
    const roleName = data?.role?.[0]?.name;
    const roleMismatch =
      Array.isArray(data?.role) &&
      data.role.length > 0 &&
      (typeof roleName !== "string" || !roles.includes(roleName));

    if (!token || roleMismatch) {
      preserveAdminThemeDuringClear(() => window.localStorage.clear());
      window.location.href = "/login";
    }
  }, [roles, data, token]);
  return <Box dir={lang == "ar" ? "rtl" : "ltr"}>{children}</Box>;
};

export default StudentWrapper;
